
import { create } from 'zustand';
import axios from "axios";

export const useStore = create((set, get) => ({

    // PostID
    voID: window.voID,

    // Save
    loaded: false,
    valid: false,

    // simulation :
    simulation: null,
    context: null,
    environment: null,

    parameters: {

    },
    widgetParameters: {}
}));

function fetchSimulation () {

    const parameters = useStore.getState().parameters;
    const widgetParameters = useStore.getState().widgetParameters;

    useStore.setState(() => {
        return {
            loaded: false,
            valid: false
        }
    })

    axios.post(
        'index.php?rest_route=/financial-simulation/v1/simulate-vo',
        {
            vo: window.voID,
            parameters: parameters,
            widgetParameters: widgetParameters
        }
    ).then((res) => {

        const data = res.data;

        useStore.setState(() => {
            return {
                loaded: true,
                valid: data.valid,
                simulation: data.hasOwnProperty('simulation') ? data.simulation : null,
                context: data.hasOwnProperty('context') ? data.context : null,
                environment: data.hasOwnProperty('environment') ? data.environment : null
            };
        });

        saveSimulationText();
    })
}

fetchSimulation();


export function getPrimaryText () {

    let result = '';
    const simulation = useStore.getState().simulation;
    const primaryText = simulation.teaser.primarytext;

    for(let key in primaryText) {
        if(!primaryText.hasOwnProperty(key)) {
            continue;
        }
        // S'il y a des arguments, on va chercher la valeur
        const primaryTextRow = primaryText[key];
        let rowText = primaryTextRow.text;
        if(primaryTextRow.hasOwnProperty('arguments')) {
            for(let index in primaryTextRow.arguments) {
                const dataKey = primaryTextRow.arguments[index];
                const value = Math.round(simulation.teaser.data[dataKey].amountInclTax) + ' €';

                rowText = rowText.replace('{' + index + '}', value);
            }
        }
        result += rowText;
    }

    return result;
}

export function handleSimulationValidation (response) {

    useStore.setState(() => {
        return {
            parameters: response.parameters,
            widgetParameters: response.widgetParameters
        }
    });

    fetchSimulation();
}

/**
 * Stocke le résumé du financement dans les input cachés des formulaires
 */
function saveSimulationText () {

    const context = useStore.getState().context;
    const simulation = useStore.getState().simulation;

    if(context.hasOwnProperty('parameters')) {
        const simulationSummary = buildSimulationText(context.parameters, simulation);
        window.voFinancialSimulationSummaryValue = simulationSummary;
        document.querySelectorAll('input[name="details-simulation"]').forEach((element) => {
            element.value = simulationSummary;
        });
    }
}

/**
 * Génère le résué du financement
 * @param parameters
 * @param simulation
 * @returns {string}
 */
function buildSimulationText (parameters, simulation) {

    return `
        Détails de la simulation :
            Loyer mensuel : ${simulation.teaser.data.regularPayment.amountInclTax}€
            Nombre de mois : ${parameters.duration}
            Taux du premier loyer : ${parameters.deposit}%
            Kilométrage annuel : ${parameters.annualMileage}kms
            Services : ${parameters.services.filter((service) => service.included).map((service) => service.serviceCode).join('')}
    `;
}